import { Palette } from './types'

export const paletteChromakey: Palette = {
    global: {
        focusIndicatorColor: 'transparent',
        iconColor: '',
    },
    header: {
        logo: <></>,
        titleColor: '',
        panelBackgroundColor: '',
        panelFilter: '',
        panelBorder: '',
        linkColor: '',
        dropdownTextColor: '',
        dropdownIconColor: '',
        dropdownBgColor: '',
        dropdownBorderColor: '',
    },
    transcript: {
        toolbarOuterBackground: '#00B140',
        toolbarInnerBackground: 'transparent',
        speakerColors: ['#020219', '#ffffff', '', '', '', ''],
        timestampColors: ['#4E4E5F', '#E4E4E5', '', '', '', ''],
        appBackgroundColors: [
            { colorValue: '#00B140', colorTitle: 'Green Chromakey' },
            { colorValue: '#020219', colorTitle: 'Black' },
        ],
        textColors: [
            { colorValue: '#000000', colorTitle: 'Black' },
            { colorValue: '#ffffff', colorTitle: 'White' },
            { colorValue: '', colorTitle: '' },
            { colorValue: '', colorTitle: '' },
            { colorValue: '', colorTitle: '' },
            { colorValue: '', colorTitle: '' },
        ],
        textBackgroundColors: [
            { colorValue: '#00B140', colorTitle: 'Green' },
            { colorValue: '#020219', colorTitle: 'Black' },
            { colorValue: '', colorTitle: '' },
            { colorValue: '', colorTitle: '' },
            { colorValue: '', colorTitle: '' },
            { colorValue: '', colorTitle: '' },
        ],
        loaderColor: '#000000',
        searchResultHighlight: '',
        activeParagraphOutline: '',
    },
    toolbar: {
        btnColor: '',
        btnHoverColor: '',
        mobilePanelBorder: '',
        mobilePanelIconColor: '',
        extrasIconColor: '',
        extrasTextColor: '',
        extrasBackground: '',
        sessionDetailsColor: '',
    },
    verbitButton: {
        primaryBackgroundColor: '',
        primaryHoverBgColor: '',
        primaryBorderColor: '',
        primaryHoverBorderColor: '',
        primaryTextColor: '',
        secondaryBackgroundColor: '',
        secondaryHoverBgColor: '',
        secondaryBorderColor: '',
        secondaryHoverBorderColor: '',
        secondaryTextColor: '',
    },
    verbitModal: {
        backgroundColor: '',
        titleColor: '',
        subtitleColor: '',
        textColor: '',
        closeIconColor: '',
        closeHoverBgColor: '',
    },
    verbitCheckbox: {
        labelColor: '',
        boxBorderColor: '',
        checkedBoxBgColor: '',
        checkedBoxIconColor: '',
    },
    verbitSelect: {
        borderColor: '',
        valueColor: '',
        indicatorColor: '',
        focusedShadow: '',
        listBgColor: '',
        listShadow: '',
        optionColor: '',
        checkIconColor: '',
        optionFocusedBgColor: '',
    },
    search: {
        outerBorderColor: '',
        innerBorderColor: '',
        inputBgColor: '',
        textColor: '',
        placeholderColor: '',
        clearButtonColor: '',
        navButtonColor: '',
        resultsColor: '',
    },
    fontSizeControl: {
        backgroundColor: '',
        iconColor: '',
        textColor: '',
        optionHoverColor: '',
        delimiterColor: '',
    },
    downloadControl: {
        backgroundColor: '',
        textColor: '',
        optionHoverColor: '',
    },
    themeToggle: {
        backgroundColor: '',
        iconColor: '',
        textColor: '',
        titleColor: '',
        colorOptionsBgColor: '',
        fontOptionsBorderColor: '',
        defaultColorIndicatorStroke: '',
        colorIndicatorActiveColor: '',
        mobileColorIndicatorBorderColor: '',
        mobileButtonBorderColor: '',
        mobileActiveColor: '',
    },
    languageSelect: {
        desktopTextColor: '',
        desktopBgColor: '',
        mobileTextColor: '',
        iconColor: '',
        separatorColor: '',
        mobileTitleColor: '',
        mobileBgColor: '',
    },
    toast: {
        backgroundColor: '',
        borderColor: '',
        textColor: '',
        successTextColor: '',
        actionColor: '',
        successIconColor: '',
        infoIconColor: '',
        closeIconColor: '',
        shadow: '',
    },
    scrollDownButton: {
        borderColor: '#757584',
        shadow: '0px 2px 10px 4px rgb(255 255 255 / 10%)',
        attentionPulseColor: '#40E0D0',
        autoscrollOff: {
            iconColor: '#ffffff',
            backgroundColor: '#252536',
        },
        autoscrollOn: {
            iconColor: '#40E0D0',
            backgroundColor: '#163F3C',
        },
    },
    inconsistencyIndicator: {
        color: '',
        hoverBackgroundColor: '',
        selectedContentColor: '',
        paragraphHoverBackgroundColor: '',
    },
    routingError: {
        backgroundColor: '',
        textColor: '',
        linkColor: '',
    },
    editor: {
        activeMediaTimingHighlight: '',
    },
    verbitSwitch: {
        default: '#ffffff',
        trackActiveBgColor: '#139346',
        trackInactiveBgColor: '#747483',
    },
    quickActionMenu: {
        backgroundColor: '',
        dividerColor: '',
        buttonColor: '',
        buttonHoverBgColor: '',
        buttonDisabledColor: '',
    },
}
